// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__CcEQO","container":"styles_container__Giex1"};